import { signal } from '@preact/signals-react'

export const componentConfigSchemaSignal = signal({})
export const componentConfigSchemaIsMigratedSignal = signal(false)
export const componentConfigSchemaErrorSignal = signal(null)
export const componentConfigSchemaLoadedSignal = signal(false)
export const componentConfigSchemaVersionSignal = signal(null)

//utgGlobal
export const ccSchemaUtgGlobalSignal = signal(null)
//coreGlobal
export const ccSchemaCoreGlobalSignal = signal(null)
//proactorSupervisor
export const ccSchemaProactorSupervisorSignal = signal(null)
//expressManager
export const ccSchemaExpressManagerSignal = signal(null)
//mailServer
export const ccSchemaMailServerSignal = signal(null)
//webServer
export const ccSchemaWebServerSignal = signal(null)
//apiInterfaceConfig
export const ccSchemaApiInterfaceConfigSignal = signal(null)